import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isDefinedString, reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import { USER_ADVANCED_PHOTO_SIZE } from "../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import PictureStatusIcon from "../../../../core/et3-pop-up-album/PictureStatusIcon";
import SelfieVerifiedIcon from "../../../../core/et3-pop-up-album/SelfieVerifiedIcon";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";

const KhattabatUserPhoto = withLiteObserverAndTheme(() => {
  const {
    currentUserId,
    userData,
    userAlbumIndex,
    getImageData,
    getImageSource,
    showNextPicture,
    showPreviousPicture
  } = getUserAdvancedStore();
  const data = userData.get(currentUserId.get());
  const pictures = reduce(() => data.pictures, []);
  const currentIndex = reduce(() => userAlbumIndex.get(), 0);
  const { source, isPictureActive, profilePictureStatus, selfieVerified } =
    getImageData(pictures[currentIndex]);
  const hasPictureSource = pictures.length > 0 && isDefinedString(source);

  return (
    <Stack spacing={1} alignItems="center">
      <Box
        sx={{
          position: "relative",
          width: USER_ADVANCED_PHOTO_SIZE,
          height: USER_ADVANCED_PHOTO_SIZE
        }}
      >
        {hasPictureSource ? (
          <Box
            component="img"
            src={source}
            alt={i18n.get("USER")}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 2
            }}
          />
        ) : (
          <Avatar
            variant="rounded"
            sx={{ width: "100%", height: "100%", bgcolor: "grey.200" }}
          >
            <PhotoCameraIcon sx={{ fontSize: 64, color: "grey.500" }} />
          </Avatar>
        )}
        {isDefinedString(source) && selfieVerified === "Y" ? (
          <Box sx={{ position: "absolute", top: 8, left: 8 }}>
            <SelfieVerifiedIcon />
          </Box>
        ) : null}
        {isDefinedString(source) ? (
          <Box sx={{ position: "absolute", top: 8, right: 8 }}>
            <PictureStatusIcon
              statusImage={getImageSource(
                isPictureActive,
                profilePictureStatus
              )}
            />
          </Box>
        ) : null}
      </Box>
      {pictures.length > 0 ? (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <IconButton
            size="small"
            aria-label={i18n.get("KHATTABAT_PREVIOUS")}
            onClick={showPreviousPicture}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="body2">{`${currentIndex + 1} / ${pictures.length}`}</Typography>
          <IconButton
            size="small"
            aria-label={i18n.get("KHATTABAT_NEXT")}
            onClick={showNextPicture}
          >
            <ChevronRightIcon />
          </IconButton>
          <IconButton
            size="small"
            aria-label={i18n.get("USER_ALBUM_PICTURES")}
            onClick={getCorePopUpStore().openPicAlbumPopUp}
          >
            <PhotoLibraryIcon />
          </IconButton>
        </Stack>
      ) : null}
    </Stack>
  );
});

export default KhattabatUserPhoto;
